<template>
  <div class="container">
    <div class="horizontal-scroll-container mb-4">
      <div class="row flex-nowrap w-100 align-items-center">
        <div class="col col-fixed" v-for="(media, index) in medias" :key="index">
          <Media :media="media"
                 :index="index"
                 :is-paid="isPaid"
                 :digital-item-id="digitalItemId"
                 :gallery="gallery"
                 @firstVisible="$emit('nextPage')"
                 @select="$emit('select', $event)"/>
        </div>
        <!-- Load more sentinel -->
        <div ref="sentinel" class="sentinel" v-show="paginate">
          <view-loader :padding-classes="'py-0'" v-if="loading"/>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import ViewLoader from "@/components/ViewLoader.vue";
import Media from "@/domain/media/galleries/medias/Media.vue";

export default {
  name: "HorizontalMedias",
  components: {Media, ViewLoader},
  emits: ['nextPage', 'select'],
  props: {
    medias: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    paginate: {
      type: Boolean,
      required: true
    },
    isPaid: {
      type: Boolean,
      required: false
    },
    digitalItemId: {
      type: Number,
      required: false
    },
    gallery: {
      type: Object,
      required: false
    }
  },
  computed: {},
  mounted() {
    this.createObserver();
  },
  methods: {
    createObserver() {
      const options = {
        threshold: [1]
      };
      const observer = new IntersectionObserver(this.handleIntersect, options);
      observer.observe(this.$refs.sentinel);
    },
    handleIntersect(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.$emit('nextPage')
        }
      })
    }
  }
}
</script>


<style scoped>

</style>